import React, {Component} from "react";
import configure from "../../store/configure";
import Loading from "../../component/loading/Loading";
import {Provider} from "react-redux";
import CryptoJS from "crypto-js";
import * as apiUtil from "../../util/apiUtil";

/**
 * 호스팅사 Redirect Page
 * */
class HostingSwitchPage extends Component {
    constructor(props) {
        super();

        this.setLoading = this.setLoading.bind(this);

        this.cafe24Switch = this.cafe24Switch.bind(this);

        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get("code");
        const state = searchParams.get("state");

        if(!state) {
            alert('잘못된 접근입니다 - redirect state is null');
            window.location.href = '/account/login';
        }

        let decryptedState = state.replace(/ /g, '+');
        const decryptedBytes = CryptoJS.AES.decrypt(decodeURIComponent(decryptedState), process.env.REACT_APP_AES_ENCRYPT_KEY);
        decryptedState = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));

        const hostType = decryptedState.hostType;
        switch (hostType) {
            case 'C':
                this.cafe24Switch(code, state, decryptedState);
                break;
            default:
                break;
        }
    }

    cafe24Switch(code, encryptedState, decryptedState) {
        apiUtil.asyncRequest({
            url: `/api/bizchat/user/cafe24/token?code=${code}&mallId=${decryptedState.hostId}`,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                window.location.href = `/register/info?hToken=${result.access_token}&hstate=${encryptedState}`;
            }
        });
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    render() {
        const { loading } = this.props;

        return (
            <Provider store={configure}>
                <Loading loading={loading} />
            </Provider>
        )
    }
}

export default HostingSwitchPage;